import React, { useEffect, useState } from 'react';
import { Form, Dropdown, SplitButton } from 'react-bootstrap';
// , DropdownButton
import Button from "components/Button/Button";
// import PublishButton from 'components/PublishButton/PublishButton';
import './style.css';
import axios from "axios";
import { Link } from "react-router-dom";
import ReactTooltip from 'react-tooltip';
import { local_routes } from 'utils/Routes';
import { withRouter } from "react-router-dom";
import ConfirmModal from 'components/ContactReportModal/ConfirmModal';
import Modal from "react-bootstrap/Modal";
import { assembleNickname, setLocalStorageSubVal } from "utils/Helper.js";
// import { owner_perms } from "Api/Api";

import ShareAccessModalButton from 'components/Modals/ShareAccessModalButton';
import DownloadAssetsButton from 'components/DownloadAssetsButton/DownloadAssetsButton';
import PresentationEventManageModalButton from 'components/Modals/PresentationEventManageModalButton';

function PkListTableV2 (props) {
    //const [isToggleOn, setIsToggleOn] = useState(false);
    const [isPublishedChecked, setIsPublishedChecked] = useState(false); // published
    const [edit_dropdown_option_index, setEditDropdownOptionIndex] = useState(0);
    const [publish_dropdown_option_index, setPublishDropdownOptionIndex] = useState(0);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [workspace_base_url, setWorkspaceBaseUrl] = useState('');
    const [assets_array, setAssetsArray] = useState([]);
    const [event_indicator, setEventIndicator] = useState('');
    const [user_indicator, setUserIndicator] = useState(<React.Fragment></React.Fragment>);
    //const [isPublicChecked, setIsPublicChecked] = useState(false);
    const [publish_dropdown_options,setPublishDropdownOptions] = useState([]);

    let all_publish_dropdown_options = {
        workspace_admin: [
            {
                title: 'Team View',
                //status_code: 1,
                public_status: 'private',
                icon: <i className="fa fa-user-circle"/>,
                tooltip: 'Presentation page available to anybody in your Team'
            },
            {
                title: 'Private',
                //status_code: 1,
                public_status: 'super_private',
                icon: <i className="fa fa-lock"/>,
                tooltip: 'Presentation page only available to you, Team Admins, and selected users'
            },
            {
                title: 'Public',
                //status_code: 1,
                public_status: 'public',
                icon: <i className="fa fa-users"/>,
                tooltip: 'Presentation page available to anybody on PechaKucha.com'
            }
        ],
        workspace_normal: [
            {
                title: 'Team View',
                //status_code: 1,
                public_status: 'private',
                icon: <i className="fa fa-user-circle"/>,
                tooltip: 'Presentation page available to anybody in your Team'
            },
            {
                title: 'Private',
                //status_code: 1,
                public_status: 'super_private',
                icon: <i className="fa fa-lock"/>,
                tooltip: 'Presentation page only available to you, Team Admins, and selected users'
            }
        ],
        pro: [
            {
                title: 'Public',
                //status_code: 1,
                public_status: 'public',
                icon: <i className="fa fa-users"/>,
                tooltip: 'Presentation page available to anybody on PechaKucha.com'
            },
            {
                title: 'Private',
                //status_code: 1,
                public_status: 'super_private',
                icon: <i className="fa fa-lock"/>,
                tooltip: 'Presentation page only available to you and selected users'
            },
        ],
        normal: [
            {
                title: 'Public',
                //status_code: 1,
                public_status: 'public',
                icon: <i className="fa fa-users"/>,
                tooltip: 'Presentation page available to anybody on PechaKucha.com'
            }
        ]
    }
    
    let edit_dropdown_options = [
        {
            otherpage: 'description',
            title: 'Edit Description'
        },
        {
            otherpage: 'slides',
            title: 'Edit Slides'
        },
        {
            otherpage: 'audio',
            title: 'Edit Audio'
        },
    ];
    
    //let assets_array = [];
    //let workspace_base_url = "";
    //let event_indicator = <span className="label-value">N/A</span>;
    
    useEffect(() => {
        if (props.presentation_info.status_code === 1) {
            setIsPublishedChecked(true);
        } else {
            setIsPublishedChecked(false);
        }
        //console.log("props",props);
        
        // this logic moved into SharedAccessModalButton
        
        /*
        if (props.workspace_base_url) {
            if (props.organization_user_access_level === 'admin' || props.user_access_level === 'admin') {
                setPublishDropdownOptions(all_publish_dropdown_options['workspace_admin']);
                let tmp_publish_dropdown_option_index = all_publish_dropdown_options['workspace_admin'].findIndex(item => {
                    if (item.public_status === props.presentation_info.public_status) {
                        return true;
                    }
                });
                if (tmp_publish_dropdown_option_index >= 0) {
                    setPublishDropdownOptionIndex(tmp_publish_dropdown_option_index);
                }
            } else {
                setPublishDropdownOptions(all_publish_dropdown_options['workspace_normal']);
                let tmp_publish_dropdown_option_index = all_publish_dropdown_options['workspace_normal'].findIndex(item => {
                    if (item.public_status === props.presentation_info.public_status) {
                        return true;
                    }
                });
                if (tmp_publish_dropdown_option_index >= 0) {
                    setPublishDropdownOptionIndex(tmp_publish_dropdown_option_index);
                }
            }
        } else if (props.user_account_level === 'private' || props.user_access_level === 'admin') {
            setPublishDropdownOptions(all_publish_dropdown_options['pro']);
            let tmp_publish_dropdown_option_index = all_publish_dropdown_options['pro'].findIndex(item => {
                if (item.public_status === props.presentation_info.public_status) {
                    return true;
                }
            });
            if (tmp_publish_dropdown_option_index >= 0) {
                setPublishDropdownOptionIndex(tmp_publish_dropdown_option_index);
            }
        } else {
            // normal public view
            setPublishDropdownOptions(all_publish_dropdown_options['normal']);
            let tmp_publish_dropdown_option_index = all_publish_dropdown_options['normal'].findIndex((item,index) => {
                if (item.public_status === props.presentation_info.public_status) {
                    return index;
                }
            });
            if (tmp_publish_dropdown_option_index >= 0) {
                setPublishDropdownOptionIndex(tmp_publish_dropdown_option_index);
            }
        }
        
        if ('current_slide_count' in props.presentation_info) {
            // newer PK that has this attribute
            if (props.presentation_info.current_slide_count !== props.presentation_info.slide_count) {
                setEditDropdownOptionIndex(1);
            } else if (!props.presentation_info.audio_url && !props.presentation_info.presenter_video_url) {
                setEditDropdownOptionIndex(2);
            }
        }
        */

        // this logic moved into DownloadAssetsButton
        /*
        let assets_array = [];
        // all users get this for now
        if (props.presentation_info.presentation_pptx_url) {
            let asset_download_obj = {
                asset_url: props.presentation_info.presentation_pptx_url,
                dropdown_option: <i className="fa fa-file-powerpoint-o"> Pptx (Powerpoint) File</i>
            }
            assets_array.push(asset_download_obj);
        }
        // only pro/workspace users get this for now
        if (props.workspace_base_url || props.user_access_level === 'admin' || props.user_account_level === 'private') {
            if (props.presentation_info.download_presentation_video_url) {
                let asset_download_obj = {
                    asset_url: props.presentation_info.download_presentation_video_url,
                    dropdown_option: <i className="fa fa-file-video-o"> Mp4 (Video) File</i>
                }
                assets_array.push(asset_download_obj);
            }
            if (props.presentation_info.audio_url) {
                let asset_download_obj = {
                    asset_url: props.presentation_info.audio_url,
                    dropdown_option: <i className="fa fa-file-audio-o"> Mp3 (Audio) File</i>
                }
                assets_array.push(asset_download_obj);
            }
            if (props.presentation_info.download_raw_image_zip_url) {
                let asset_download_obj = {
                    asset_url: props.presentation_info.download_raw_image_zip_url,
                    dropdown_option: <i className="fa fa-file-archive-o"> Slide Images (Zip) File</i>
                }
                assets_array.push(asset_download_obj);
            }
        } else if (owner_perms.organizations) {
            // remind that they need to be in team
            let asset_download_obj = {
                //asset_url: local_routes.pricing,
                dropdown_option:
                    <React.Fragment>
                        <i className="fa fa-file-video-o"> Mp4 (Video) File</i>
                        <span style={{ fontSize: "smaller",color: "#16a085" }}> *Requires PK Create Team View*</span>
                    </React.Fragment>

            }
            assets_array.push(asset_download_obj);
            asset_download_obj = {
                //asset_url: local_routes.pricing,
                dropdown_option:
                    <React.Fragment>
                        <i className="fa fa-file-audio-o"> Mp3 (Audio) File</i>
                        <span style={{ fontSize: "smaller",color: "#16a085" }}> *Requires PK Create Team View*</span>
                    </React.Fragment>
            }
            assets_array.push(asset_download_obj);
            asset_download_obj = {
                //asset_url: local_routes.pricing,
                dropdown_option:
                    <React.Fragment>
                        <i className="fa fa-file-archive-o"> Slide Images (Zip) File</i>
                        <span style={{ fontSize: "smaller",color: "#16a085" }}> *Requires PK Create Team View*</span>
                    </React.Fragment>
            }
            assets_array.push(asset_download_obj);
        } else {
            // upsell
            let asset_download_obj = {
                asset_url: local_routes.pricing,
                dropdown_option:
                    <React.Fragment>
                        <i className="fa fa-file-video-o"> Mp4 (Video) File</i>
                        <span style={{ fontSize: "smaller",color: "#16a085" }}> *Requires PK Create PRO*</span>
                    </React.Fragment>

            }
            assets_array.push(asset_download_obj);
            asset_download_obj = {
                asset_url: local_routes.pricing,
                dropdown_option:
                    <React.Fragment>
                        <i className="fa fa-file-audio-o"> Mp3 (Audio) File</i>
                        <span style={{ fontSize: "smaller",color: "#16a085" }}> *Requires PK Create PRO*</span>
                    </React.Fragment>
            }
            assets_array.push(asset_download_obj);
            asset_download_obj = {
                asset_url: local_routes.pricing,
                dropdown_option:
                    <React.Fragment>
                        <i className="fa fa-file-archive-o"> Slide Images (Zip) File</i>
                        <span style={{ fontSize: "smaller",color: "#16a085" }}> *Requires PK Create PRO*</span>
                    </React.Fragment>
            }
            assets_array.push(asset_download_obj);
        }
        setAssetsArray(assets_array);
        */
        
        /*
        if (props.workspace_base_url) {
            setWorkspaceBaseUrl(props.workspace_base_url);
        }
        */
        
        // event_indicator could be text (non-published event), link (published event), or dropdown (to submit to community PK events)
        
        let event_indicator =
            <span data-tip="Presentation is not part of a PechaKucha Event" className="label-value">
                None
                <ReactTooltip />
            </span>;
            
        if (props.presentation_info.event_entity_name) {
            if (props.presentation_info.event_friendly_url) {
                event_indicator = 
                    <Link to={`${props.workspace_base_url}${local_routes.events}/${props.presentation_info.event_friendly_url}`}
                        style={{ color: '#007bff' }}>
                        <span data-tip="Click to visit the associated Event page" className="label-value">
                            {props.presentation_info.event_entity_name}
                            <ReactTooltip />
                        </span>
                    </Link>
                ;
            } else {
                event_indicator =
                    <span data-tip="Associated Event is not currently published" className="label-value">
                        {props.presentation_info.event_entity_name}
                        <ReactTooltip />
                    </span>;
            }
        } else if (props.source_info.entity_type === 'users') {
            if (props.presentation_info.possible_community_events && props.presentation_info.possible_community_events.length > 1) {
                event_indicator =
                    <span data-tip="Click below to submit your Presentation to a PechaKucha Event" className="label-value">
                        Invitations Available
                        <ReactTooltip />
                    </span>;
                /*
                event_indicator = 
                    <div className="">
                        <Form>
                            <Form.Group className="mb-0">
                                <div
                                    data-tip={props.presentation_info.status_code === 1 ? "Submit your Presentation to a PechaKucha Event!" : "Must publish before submitting"}
                                    className=""
                                >
                                    <Form.Control
                                        disabled={props.presentation_info.status_code !== 1}
                                        as="select"
                                        required
                                        onChange={submitCommunityPk}
                                        defaultValue={props.presentation_info.possible_community_events[0].entity_name}
                                    >
                                        {
                                            props.presentation_info.possible_community_events.map((item, index) =>
                                                <option value={index} key={index}>{item.entity_name}</option>
                                            )
                                        }
                                    </Form.Control>
                                    <ReactTooltip />
                                </div>
                            </Form.Group>
                        </Form>
                    </div>
                ;
                */
            }
        }
        setEventIndicator(event_indicator);
        
        if (props.workspace_base_url && props.source_info.entity_type === 'organizations') {
            // setup user_indicator
            
            if (props.presentation_info.users) {
                let tmp_user_indicator = <React.Fragment></React.Fragment>;
                let nickname = '';
                let presentation_creator = props.presentation_info.users.find(element => element.xref_data && element.xref_data.entity_owner_integer && element.xref_data.entity_owner_integer === 1);
                if (presentation_creator) {
                    nickname = assembleNickname(presentation_creator);
                }
                if (nickname && presentation_creator.friendly_url) {
                    tmp_user_indicator =
                        <Link to={`${props.workspace_base_url}${local_routes.users}/${presentation_creator.friendly_url}`}
                            style={{ color: '#007bff' }}>
                            <span data-tip="Click to visit user's Profile page" className="label-value">
                                {nickname}
                                <ReactTooltip />
                            </span>
                        </Link>;
                    setUserIndicator(tmp_user_indicator);
                }
            }

        }
        
        //console.log(" PKListTableV2",props.presentation_info.editable);
    }, [props])

    function onPublishedCheckboxSelect() {
        if (isPublishedChecked === true) {
            props.togglePublish(false, props.presentation_info, props.index)
        }
        else {
            props.togglePublish(true, props.presentation_info, props.index)
        }
        setIsPublishedChecked(!isPublishedChecked);
    }

    // function submitCommunityPk (e) {
    //     console.log("submitCommunityPk",props.presentation_info,e.target.value);
    //     if (props.OnSubmitCommunityPk && e.target.value > 0) {
    //         props.OnSubmitCommunityPk(props.presentation_info,e.target.value);
    //     }
    // }

    function onClickDeletePresentation () {
        console.log("onClickDeletePresentation");
        setShowConfirmModal(true);
    }

    /*
    function onClickPublishDropdown (tmp_publish_dropdown_option_index) {
        console.log("onClickPublishDropdown",tmp_publish_dropdown_option_index);
        if (tmp_publish_dropdown_option_index === publish_dropdown_option_index) {
            // already set - do nothing
            return;
        }
        setPublishDropdownOptionIndex(tmp_publish_dropdown_option_index);
        props.OnChangePublishOption(publish_dropdown_options[tmp_publish_dropdown_option_index],props.presentation_info,props.index);
        //setEditDropdownOptionIndex(edit_dropdown_option_index);
        //props.history.push(`${workspace_base_url}${local_routes.pkcreation}/${props.presentation_info.entity_uuid}/${edit_dropdown_options[edit_dropdown_option_index].otherpage}`);
    }
    */

    function onClickEditDropdown (tmp_edit_dropdown_option_index) {
        
        setEditDropdownOptionIndex(tmp_edit_dropdown_option_index);
        let new_url = `${props.workspace_base_url}${local_routes.pkcreation}/${props.presentation_info.entity_uuid}/${edit_dropdown_options[tmp_edit_dropdown_option_index].otherpage}`
        console.log("onClickEditDropdown",tmp_edit_dropdown_option_index,new_url);
        props.history.push({
            pathname: new_url,
            data: {
                source: {
                    referrer: props.referrer
                }
            }
        });
        //props.history.push(new_url);
    }

    // Toogles modal show
    function showEmbedModal () {
        setShowConfirmModal(true);
        //this.setState({ showEmbedModal: true });
        //return null;
    }
    // Toogles modal hide
    function hideConfirmModal () {
        setShowConfirmModal(false);
        //this.setState({ showEmbedModal: false });
        //return null;
    }

    function onClickDuplicatePresentation (organizations_friendly_url = null) {
        console.log("OnDuplicate",organizations_friendly_url,props.presentation_info.entity_uuid);
        //setShowConfirmModal(false);
        props.OnDuplicatePresentation(props.presentation_info.entity_uuid,props.index,organizations_friendly_url);
    }

    function OnConfirmDelete () {
        console.log("OnConfirmDelete",props.presentation_info.entity_uuid);
        setShowConfirmModal(false);
        props.OnDeletePresentation(props.presentation_info.entity_uuid,props.index);
    }
    
    function leaveTeamWorkspace () {
      console.log("leaveTeamWorkspace");
      axios.defaults.headers.common['X-PK-Organization'] = '';
      setLocalStorageSubVal("PersistentUserState",'org_friendly_url','');
      setLocalStorageSubVal("PersistentUserState",'org_account_level','');
      setLocalStorageSubVal("PersistentUserState",'org_name','');
      setLocalStorageSubVal("PersistentUserState",'org_uuid','');
    }

/*
                    { props.presentation_info.presentation_pptx_url &&
                        <div>
                        <a data-tip="Download Pptx file" href={props.presentation_info.presentation_pptx_url} rel="noopener noreferrer">
                            <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5"><i className="fa fa-file-powerpoint-o"></i></Button>
                        </a>
                        <ReactTooltip />
                        </div>
                    }
                    { props.presentation_info.download_presentation_video_url &&
                        <div>
                        <a data-tip="Download Video file" href={props.presentation_info.download_presentation_video_url} rel="noopener noreferrer">
                            <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5"><i className="fa fa-file-video-o"></i></Button>
                        </a>
                        <ReactTooltip />
                        </div>
                    }
*/

    //console.log("RENDER",publish_dropdown_option_index,publish_dropdown_options);
    
    /*
    let displayed_title = props.presentation_info.entity_name;
    if (props.presentation_info.status_code === 1 && publish_dropdown_options.length > 0) {
        displayed_title = <i className="fa fa-check">&nbsp;{publish_dropdown_options[publish_dropdown_option_index].title}</i>;
    }
    */
    
    return (
        <tr key={props.presentation_info.entity_uuid}>
            <td style={{ fontSize: "smaller" }} className="pkCheckbox">
                <div className="React__checkbox">
                    <span className="React__checkbox--span" />
                    {( props.presentation_info.public_status === 'public' && props.presentation_info.organizations_uuid) ?
                      <React.Fragment>
                        {props.presentation_info.status_code === 1 ?
                            <React.Fragment>
                              <Link to={`${props.workspace_base_url}${local_routes.presentations}/${props.presentation_info.friendly_url}`}
                                  style={{ marginBottom: '3px', color: '#007bff' }}>
                                  <span data-tip="Click to visit Team Presentation page and view video" className="label-value">
                                      {props.presentation_info.entity_name}
                                      <ReactTooltip />
                                  </span>
                              </Link>
                              <br/>
                              <a onClick={leaveTeamWorkspace} href={`${local_routes.presentations}/${props.presentation_info.friendly_url}`}
                                  style={{ color: '#007bff' }}>
                                  <span data-tip="Click to leave your Team workspace, and visit the *Public* Presentation page and view video" className="label-value">
                                      {props.presentation_info.entity_name}<span style={{ verticalAlign: "super", fontSize: "x-small", color: "#E50114" }}> PUBLIC</span>
                                      <ReactTooltip />
                                  </span>
                              </a>
                            </React.Fragment>
                            :
                            <span data-tip="Presentation in 'Draft' mode - page and video not available" className="label-value">
                                {props.presentation_info.entity_name}
                                <ReactTooltip />
                            </span>
                        }
                      </React.Fragment>
                      :
                      <React.Fragment>
                        {props.presentation_info.status_code === 1 ?
                            <Link to={`${props.workspace_base_url}${local_routes.presentations}/${props.presentation_info.friendly_url}`}
                                style={{ color: '#007bff' }}>
                                <span data-tip="Click to visit Presentation page and view video" className="label-value">
                                    {props.presentation_info.entity_name}
                                    <ReactTooltip />
                                </span>
                            </Link>
                            :
                            <span data-tip="Presentation in 'Draft' mode - page and video not available" className="label-value">
                                {props.presentation_info.entity_name}
                                <ReactTooltip />
                            </span>
                        }
                      </React.Fragment>
                    }
                    {/*
                    {(props.presentation_info.status_code === 1 && props.presentation_info.public_status && props.presentation_info.public_status === 'public') &&
                        <Link
                            to={`${local_routes.presentations}/${props.presentation_info.friendly_url}`}
                            style={{ color: '#007bff' }}
                        >
                            <span style={{ fontSize: "smaller" }} data-tip="Click to visit *Public* Presentation page" className="label-value">
                                <br/>&nbsp;Public Link
                                <ReactTooltip />
                            </span>
                        </Link>
                    }
                    */}
                </div>
            </td>
            { props.workspace_base_url && props.source_info.entity_type === 'organizations' ?
                <td style={{ fontSize: "smaller" }}>
                    {user_indicator}
                </td>
                : null
            }
            {/* <td>{props.locations_text === undefined ? "N/A" : props.locations_text}</td>*/}
            <td style={{ fontSize: "smaller" }}>
                {event_indicator}<br/>
                <PresentationEventManageModalButton
                    entity_info={{...props.presentation_info,entity_type:'presentations'}}
                />
                
                
            </td>
            {/* <td className="pkDate">{props.Push_date === undefined && props.Push_month === undefined ? "N/A" : `${props.Push_date}${props.Push_month}`}</td> */}
            <td className="pkDate">
                {new Date(props.presentation_info.created_time * 1000).toLocaleDateString()}
            </td>
            <td className="pkNotes">{props.presentation_info.notes}</td>
            <td className="">
              {/*
              <PublishButton
                entity_info={
                  {
                    status_code:props.presentation_info.status_code,
                    entity_uuid:props.presentation_info.entity_uuid,
                    entity_type:'presentations',
                    publishable: props.presentation_info.publishable && props.user_status_code === "1"
                  }
                }
              />
              */}
            
                      
                <div className="">
                    <Form>
                        <Form.Group className="mb-0">
                            <div data-tip={isPublishedChecked ? "Uncheck to Unpublish Presentation" : "Check to Publish Presentation"} className="">
                                <label className="check-box">
                                    <input type="checkbox"
                                        disabled={!props.presentation_info.publishable || props.user_status_code !== "1"}
                                        //disabled={true}
                                        className="React__checkbox--input"
                                        name="public_status"
                                        onChange={() => onPublishedCheckboxSelect('isPublishedChecked')}
                                        checked={isPublishedChecked} />
                                    <span style={{ cursor: "pointer" }} className="React__checkbox--span" />
                                </label>
                                <ReactTooltip />
                            </div>
                            
                        </Form.Group>
                    </Form>
                </div>
                
            </td>
            <td className="">
                {/*
                { publish_dropdown_options.length === 1 &&
                    <span data-tip={publish_dropdown_options[publish_dropdown_option_index].tooltip}>
                        {publish_dropdown_options[publish_dropdown_option_index].title}
                        <ReactTooltip />
                    </span>
                }
                { publish_dropdown_options.length > 1 &&
                    <ShareAccessModalButton
                        entity_info={{...props.presentation_info,entity_type:'presentations'}}
                        publish_dropdown_options={publish_dropdown_options}
                        publish_dropdown_option_index={publish_dropdown_option_index}
                        OnChangePublishOption={props.OnChangePublishOption}
                        index={props.index}
                        //button_text='Share'
                        //button_icon=<i className="fa fa-lock"/>
                    />
                }
                */}
                    <ShareAccessModalButton
                        entity_info={{...props.presentation_info,entity_type:'presentations'}}
                        //publish_dropdown_options={publish_dropdown_options}
                        //publish_dropdown_option_index={publish_dropdown_option_index}
                        OnChangePublishOption={props.OnChangePublishOption}
                        index={props.index}
                        //button_text='Share'
                        //button_icon=<i className="fa fa-lock"/>
                    />

                {/*
                 { publish_dropdown_options.length > 0 &&
                    <ShareAccessModalButton
                        entity_info={{...props.presentation_info,entity_type:'presentations'}}
                        //publish_dropdown_options={publish_dropdown_options}
                        //publish_dropdown_option_index={publish_dropdown_option_index}
                        OnChangePublishOption={props.OnChangePublishOption}
                        index={props.index}
                        //button_text='Share'
                        //button_icon=<i className="fa fa-lock"/>
                    />
                }
                */}
                {/*
                { publish_dropdown_options.length === 1 &&
                    <span data-tip={publish_dropdown_options[publish_dropdown_option_index].tooltip}>
                        {publish_dropdown_options[publish_dropdown_option_index].title}
                        <ReactTooltip />
                    </span>
                }
                { publish_dropdown_options.length > 1 &&
                        <SplitButton
                            //className="my_button"
                            //bsPrefix="my_button"
                            data-tip={publish_dropdown_options[publish_dropdown_option_index].tooltip}
                            variant="pk"
                            //bsClass="my_button"
                            style={{ fontSize: "smaller" }}
                            alignRight
                            size="sm"
                            //iconClass="fa fa-file-powerpoint-o"
                            title={publish_dropdown_options[publish_dropdown_option_index].title}
                            //title={'Edit'}
                            drop={'left'}
                            onClick={() => onClickPublishDropdown(publish_dropdown_option_index)}
                            //disabled={!props.presentation_info.publishable || props.user_status_code !== "1"}
                            //href={`${workspace_base_url}${local_routes.pkcreation}/${props.presentation_info.entity_uuid}/${edit_dropdown_options[edit_dropdown_option_index].otherpage}`}
                        >
                        {
                            publish_dropdown_options.map((item,index) => {
                                if (index === publish_dropdown_option_index) {
                                    return <React.Fragment key={index}></React.Fragment>;
                                }
                                return (
                                    <Dropdown.Item
                                        style={{ fontSize: "smaller" }}
                                        key={index}
                                        //disabled={!props.presentation_info.publishable || props.user_status_code !== "1"}
                                        onClick={() => onClickPublishDropdown(index)}
                                        //href={item.asset_url}
                                        //rel="noopener noreferrer"
                                    >
                                        Set to {item.title}
                                    </Dropdown.Item>
                                );
                            })
                        }
                        </SplitButton>
                }
                */}
            </td>
            <td className="">
                <DownloadAssetsButton
                    entity_info={{...props.presentation_info,entity_type:'presentations'}}
                />
                {/*
                    <React.Fragment>
                        { assets_array.length > 0 &&
                            <DropdownButton
                                //id="dropdown-basic-button"
                                data-tip="Download Files"
                                title={<i className="fa fa-download"></i>}
                                alignRight
                                drop={'down'}
                                size="sm"
                            >
                                
                            {
                                assets_array.map((item,index) => {
                                    return (
                                        <Dropdown.Item
                                            data-tip=""
                                            key={index}
                                            target={item.asset_url === local_routes.pricing ? "_blank" : ""}
                                            data-tip=""
                                            href={item.asset_url || ''}
                                            rel="noopener noreferrer"
                                        >
                                            {item.dropdown_option}
                                            
                                        </Dropdown.Item>
                                    );
                                })
                            }
                                <ReactTooltip />
                            </DropdownButton>
                        }
                    </React.Fragment>
                    :
                    <React.Fragment>
                    
                        <span data-tip="Upgrade to PK Create Pro to Download Your Presentation">
                            <i className="fa fa-download"></i>
                            <ReactTooltip />
                        </span>
                    </React.Fragment>
                */}
            </td>
            <td style={{ textAlign: "right" }} className="">
                {
                    props.presentation_info.editable &&
                        <React.Fragment>
                        <div>
                            <SplitButton
                                style={{ fontSize: "smaller" }}
                                alignRight
                                size="sm"
                                title={edit_dropdown_options[edit_dropdown_option_index].title}

                                drop={'left'}
                                onClick={() => onClickEditDropdown(edit_dropdown_option_index)}
                            >
                                { props.user_status_code && props.user_status_code === "1" &&
                                <React.Fragment>
                                    <Dropdown.Item
                                        style={{ fontSize: "smaller" }}
                                        key={'delete'}
                                        onClick={() => onClickDeletePresentation()}
                                    >
                                        Delete Presentation
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        style={{ fontSize: "smaller" }}
                                        key={'duplicate'}
                                        onClick={() => onClickDuplicatePresentation()}
                                    >
                                        Duplicate Presentation
                                    </Dropdown.Item>
                                    {props.user_organizations.map((item,index) => 
                                       <Dropdown.Item
                                            style={{ fontSize: "smaller" }}
                                            key={'duplicate_workspace_'+item.entity_uuid}
                                            onClick={() => onClickDuplicatePresentation(item.friendly_url)}
                                        >
                                            Duplicate Presentation into Team {item.entity_name}
                                        </Dropdown.Item>                                    
                                    )}
                                    <Dropdown.Divider />
                                </React.Fragment>
                                }

                            {
                                edit_dropdown_options.map((item,index) => {
                                    if (index === edit_dropdown_option_index) {
                                        return <React.Fragment key={index}></React.Fragment>;
                                    }
                                    if (index === 2) {
                                        // allowed to edit audio?
                                        if ('current_slide_count' in props.presentation_info) {
                                            // newer PK that has this attribute
                                            if (props.presentation_info.current_slide_count !== props.presentation_info.slide_count) {
                                                return <React.Fragment key={index}></React.Fragment>;
                                            }
                                        }
                                    }
                                    return (
                                        <Dropdown.Item
                                            //data-tip={`Edit Presentation ${edit_dropdown_options[index].otherpage}`}
                                            //id="dropdown-menu-align-right"
                                            //width="200px"
                                            style={{ fontSize: "smaller" }}
                                            key={index}
                                            onClick={() => onClickEditDropdown(index)}
                                            //href={`${workspace_base_url}${local_routes.pkcreation}/${props.presentation_info.entity_uuid}/${edit_dropdown_options[index].otherpage}`}
                                        >
                                            {item.title}
                                        </Dropdown.Item>
                                    );
                                })
                            }
                                
                            </SplitButton>
                        </div>
                        <div>
                            <Modal size="sm" show={showConfirmModal} onHide={() => hideConfirmModal()} className="modal-contact-custom" >
                                <div>
                                    <ConfirmModal
                                        modalText={`The '${props.presentation_info.entity_name}' presentation will will be permanently deleted. Press 'Confirm Deletion' to continue.`}
                                        OnConfirmDelete={() => OnConfirmDelete()}
                                        hideConfirmModal={() => hideConfirmModal()}
                                    />
                                    <div>
                                        <Button theme="contact-button" OnClickMet={() => hideConfirmModal()}>
                                            x
                                        </Button>
                                    </div>
                                 </div>
                            </Modal>
                        </div>
                        </React.Fragment>
                }
            </td>
        </tr>
    )
}
export default withRouter(PkListTableV2)